var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8996 10.5423L11.3086 10.3606C11.1216 10.3387 10.9319 10.3594 10.754 10.4212C10.5761 10.4831 10.4145 10.5844 10.2814 10.7177L9.12884 11.8702C7.3508 10.9657 5.90553 9.52042 5.001 7.74237L6.15981 6.58357C6.42915 6.31423 6.56069 5.9384 6.51684 5.55631L6.33519 3.97783C6.29981 3.67222 6.15321 3.3903 5.92332 3.18584C5.69344 2.98137 5.39635 2.86864 5.0887 2.86914H4.00506C3.29725 2.86914 2.70845 3.45794 2.7523 4.16575C3.08428 9.51503 7.36245 13.7869 12.7055 14.1189C13.4133 14.1628 14.0021 13.574 14.0021 12.8662V11.7825C14.0083 11.1499 13.5323 10.6175 12.8996 10.5423Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneimage);
export default __webpack_public_path__ + "static/media/phoneimage.47753ba059eb0167f463ba7034a98963.svg";
export { ForwardRef as ReactComponent };